import Vue from 'vue';
import format from 'date-fns/format/index';

/**
 * 去掉HTML标签
 */
Vue.filter('removeHtml', input => {
  return input && input.replace(/<(?:.|\n)*?>/gm, '')
    .replace(/(&rdquo;)/g, '\"')
    .replace(/&ldquo;/g, '\"')
    .replace(/&mdash;/g, '-')
    .replace(/&nbsp;/g, '')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/<[\w\s"':=\/]*/, '');
});

Vue.filter('formatTime', (time, fmt) => {
  time *= 1;

  //  非时间戳
  if (isNaN(time) || time < 1000000000) {
    return '';
  }

  //  unixtime 转 timestamp
  if ((time + '').length === 10) {
    time *= 1000;
  }

  return format(time, fmt);
});



// WEBPACK FOOTER //
// ./app/web/framework/vue/filter/index.js